import StarRankMobileBroadcastItem from '@/components/starrank/mobile/StarRankMobileBroadcastItem';

/**
 * 별별랭킹 모바일, 테마 별 랭킹 리스트 컴포넌트
 * @param {Object} props
 * @param {{
 *  rankList: Array,
 *  title: string,
 *  detail: string,
 * }} props.broadItemList
 */
const StarRankMobileThemeRankList = ({broadItemList}) => {
  if (broadItemList?.rankList?.length > 0) {
    return (
      <section className='area_box'>
        <div className='rank-title'>
          <h3>{broadItemList.title}</h3>
          <span>{broadItemList.detail}</span>
        </div>
        <div className='broad_list_box horizon' data-type='scroll-horizon'>
          <ul className='scroll-innr'>
            {broadItemList.rankList.map((broadItem, index) => {
              return (
                <StarRankMobileBroadcastItem
                  broadItem={broadItem}
                  itemIndex={index + 1}
                  key={`broad-item-${broadItem.broadNo}-${index}`}
                />
              );
            })}
          </ul>
        </div>
      </section>
    );
  } else {
    return <></>;
  }
};

export default StarRankMobileThemeRankList;
